/**
 * @generated SignedSource<<756cd962e7e7d9e267d54feddd46ed33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventCompetitionsDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type EventCompetitionsDeleteMutation$data = {
  readonly removeEventCompetition: string;
};
export type EventCompetitionsDeleteMutation = {
  response: EventCompetitionsDeleteMutation$data;
  variables: EventCompetitionsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "removeEventCompetition",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCompetitionsDeleteMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventCompetitionsDeleteMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeEventCompetition",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4e01aec7be6b3be548e5f55f690bdf09",
    "id": null,
    "metadata": {},
    "name": "EventCompetitionsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EventCompetitionsDeleteMutation(\n  $id: ID!\n) {\n  removeEventCompetition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "ed7516ac25eb57dbd7e3a8dab249b82e";

export default node;
